export default '/build/59c89e21.svg'